"use strict";
ui.loadTemplateFile("menu.html");

class MenuDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _keyDownHandler: (event: KeyboardEvent) => void;
    _isGamemaster: boolean;

    constructor(character: any) {
        super("menu.html");
        this._isGamemaster = !!(character && character.isgm);

        ui.button(this, ".button.character").on(
            "clicked",
            this._onCharacter.bind(this)
        );
        ui.button(this, ".button.inventory").on(
            "clicked",
            this._onInventory.bind(this)
        );
        ui.button(this, ".button.quest-list").on(
            "clicked",
            this._onQuestList.bind(this)
        );
        ui.button(this, ".button.skill-list").on(
            "clicked",
            this._onSkillList.bind(this)
        );
        ui.button(this, ".button.knowledge-base").on(
            "clicked",
            this._onKnowledgeBase.bind(this)
        );
        ui.button(this, ".button.map").on("clicked", this._onMap.bind(this));
        ui.button(this, ".button.options").on(
            "clicked",
            this._onOptions.bind(this)
        );
        ui.button(this, ".button.gamemaster").on(
            "clicked",
            this._onGamemaster.bind(this)
        );

        if (!this._isGamemaster) {
            this._element.find(".button.gamemaster").hide();
        }

        this._keyDownHandler = this._onKeyDown.bind(this);
        window.addEventListener("keydown", this._keyDownHandler);
    }

    _onKeyDown(event: KeyboardEvent) {
        const target = event.target as HTMLElement;
        if (
            event.repeat || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey ||
            (window as any).debugControls ||
            (target && (
                target.tagName === "INPUT" ||
                target.tagName === "TEXTAREA" ||
                target.tagName === "SELECT" ||
                target.isContentEditable
            ))
        ) {
            return;
        }

        const shortcuts: Record<string, () => void> = {
            c: this._onCharacter,
            i: this._onInventory,
            q: this._onQuestList,
            l: this._onSkillList,
            k: this._onKnowledgeBase,
            m: this._onMap,
            o: this._onOptions,
            g: this._onGamemaster,
        };
        const action = shortcuts[event.key.toLowerCase()];
        if (action && (event.key.toLowerCase() !== "g" || this._isGamemaster)) {
            action.call(this);
        }
    }

    close() {
        window.removeEventListener("keydown", this._keyDownHandler);
        super.close();
    }

    _onCharacter() {
        this.emit("toggle-character");
    }

    _onInventory() {
        this.emit("toggle-inventory");
    }

    _onQuestList() {
        this.emit("toggle-quest-list");
    }

    _onSkillList() {
        this.emit("toggle-skill-list");
    }

    _onKnowledgeBase() {
        this.emit("toggle-knowledge-base");
    }

    _onMap() {
        this.emit("toggle-map");
    }

    _onOptions() {
        this.emit("toggle-options");
    }

    _onGamemaster() {
        this.emit("toggle-gamemaster");
    }
}

ui.MenuDialog = MenuDialog;
ui.menuDialog = function (character: any) {
    return new ui.MenuDialog(character);
};
